<div class="List">

    <template v-if="items.length == 0">

        <em>Im aktuellen Kartenausschnitt gibt es keine Einträge.</em>        
    </template>

    <template v-if="items.length > limit">

        <em>Mehr als {{limit}} Einträge im aktuellen Kartenausschnitt. Zoomen Sie weiter hinein.</em>
    
    </template>

    <template v-else>
       
        <slot v-for="item in items" :item="item"/>
            
    </template>

</div>
